import { Loading, useURL } from "@kalyzee/kast-web-sdk/web-components";
import { useNavigate } from "react-router-dom";
import { AuthStatus } from "../../interfaces/session";
import { useEffect } from "react";
import PrivatePage from "../../pages/master/common/private/private";
import { PAGE_PATHS } from "./PageContext";
import { SessionMode } from "../../store/session/slices";

export interface PrivateRouteProps {
  authStatus: AuthStatus;
  mode: SessionMode;
}

const PrivateRoute = ({ authStatus, mode }: PrivateRouteProps) => {
  const url = useURL();
  const navigate = useNavigate();

  useEffect(() => {
    const redirection = url.searchParams.get("redirect");
    if (redirection && mode === SessionMode.MASTER && url.pathname === PAGE_PATHS[SessionMode.MASTER].login) navigate(redirection);
  }, [url, mode, navigate]);

  if (authStatus !== AuthStatus.In) {
    return <Loading fullscreen />;
  }
  
  return <PrivatePage />;
};

export default PrivateRoute;
